import React from "react";

export const Empty: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center p-4">
      <span>No data available</span>
    </div>
  );
};